var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgCrop16 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crop16_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "m4.087.667-.087 10A1.333 1.333 0 0 0 5.333 12h10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.666 3.42a.667.667 0 0 0 0 1.333V3.42Zm10 .58v-.667V4Zm.667 11.333a.667.667 0 1 0 1.333 0h-1.333Zm-5.946-12H4.72v1.334h.667V3.333Zm-2.661 1.42h.666V3.42h-.666v1.333ZM12.666 12v-.667h-1.333V12h1.333Zm-1.333-1.33v.666h1.333v-.666h-1.333Zm-.667-6.003c.177 0 .346.07.471.195l.943-.943a2 2 0 0 0-1.414-.586v1.334Zm.471.195a.667.667 0 0 1 .196.471h1.333a2 2 0 0 0-.586-1.414l-.943.943Zm-5.75-.195h5.279V3.333h-5.28v1.334Zm-4.721.086h2.06V3.42H.666v1.333ZM11.333 12v3.333h1.333V12h-1.333Zm0-6.667v5.337h1.333V5.333h-1.333Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "crop16_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
});
SvgCrop16.displayName = "SvgCrop16";
export default SvgCrop16;